(function(){
    angular
        .module('app')
        .filter('myOrderBy', myOrderBy);

        myOrderBy.$inject = ['$timeout'];
        function myOrderBy($timeout){

            return function (array, property, reverse) {
            	if(array){
					var result = array.sort(function (object1, object2) {
			            if (angular.isUndefined(property)) {
			            	return object1.localeCompare(object2);
			            }
			            
			            return object1[property].localeCompare(object2[property]);
			        });
			        
			        return reverse ? result.slice().reverse() : result;
			    }
			};
        }
})();